import { render, staticRenderFns } from "./apps.vue?vue&type=template&id=2f77f560"
import script from "./apps.ts?vue&type=script&lang=js&external"
export * from "./apps.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports